import { find } from 'es-toolkit/compat';
import type { DpAttribute } from 'generated/graphql';
import moment from 'moment';

/**
 * Helper function that de-dupes time checking logic by returning the launch
 * date, if it exists, and the current time.
 * @param attributes
 * @return A tuple containing the launch date if it exists, and the current time.
 */
export function getLaunchDateAndCurrentDate(attributes?: Pick<DpAttribute, 'key' | 'value'>[]): [
  moment.Moment | undefined,
  moment.Moment,
] {
  const now = moment().utc();

  if (!attributes) {
    return [
      undefined,
      now,
    ];
  }
  const launchDateAttr = find(attributes, (attr) => attr.key === 'product_site_launch_date');
  if (!launchDateAttr) {
    return [
      undefined,
      now,
    ];
  }

  // Note: Times are written in the Dynamo table in UTC. Constructing a moment
  // as `moment()` automatically applies the current timezone to the UTC time.
  // To keep an apples-to-apples comparison with the current UTC time, we
  // explicitly import the attributes time as the UTC time.
  // See https://momentjs.com/docs/#/parsing/ for more details.
  return [
    moment.utc(launchDateAttr.value[0].value),
    now,
  ];
}
